<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card elevation="0" tile>
        <v-card-title class="grey lighten-4">
          {{ $t("hr.survey.completed_title") }}
          <v-spacer />
          <id-button @click="onRefreshData">
            <template #icon>
              <v-icon left>mdi-refresh</v-icon>
            </template>
            {{ $t("buttons.refresh") }}
          </id-button>
        </v-card-title>
        <v-data-table
          class="elevation-1"
          :headers="table.headers"
          :items="table.data"
          :options.sync="table.options"
          :server-items-length="table.totalItems"
          :loading="table.loading"
          :footer-props="{ 'items-per-page-options': [10, 25, 50, 100] }"
        >
          <template #item="row">
            <tr :active="row.selected">
              <td>
                <v-list-item class="pa-0">
                  <v-list-item-avatar
                    size="30"
                    class="white--text body-1 font-weight-medium"
                    :color="row.item.publishedSurvey.survey.color"
                  >
                    {{ row.item.publishedSurvey.survey.name.substring(0, 2).toUpperCase() }}
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="body-1">
                      {{ row.item.publishedSurvey.survey.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td>
                {{ row.item.publishedSurvey.publishDateTime | formattedDateTimeMinute }}
              </td>
              <td>
                {{ row.item.publishedSurvey.endDateTime | formattedDateTimeMinute }}
              </td>
              <td>
                {{ row.item.publishedSurvey.anonymous ? $t("hr.survey.anonymous_on") : $t("hr.survey.anonymous_off") }}
              </td>
              <td>
                {{
                  row.item.publishedSurvey.uncompletedEvaluators.length === 0
                    ? $t("hr.survey.status_enum.completed")
                    : $t("hr.survey.status_enum.continuous")
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <transition name="slide-in-left">
          <router-view @success:save="onRefreshData" />
        </transition>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import { COMPLETED_SURVEY_RESULTS } from "./query";

  export default {
    name: "PendingSurveyResults",
    data: vm => ({
      table: {
        loading: false,
        data: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ["publishedSurvey.publishDateTime"],
          sortDesc: [true]
        },
        totalItems: 0,
        selected: [],
        headers: [
          {
            text: vm.$t("hr.survey.name"),
            value: null,
            align: "start",
            sortable: false,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.survey.published_date"),
            value: "publishedSurvey.publishDateTime",
            align: "start",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.survey.end_date"),
            value: "publishedSurvey.endDateTime",
            align: "start",
            sortable: true,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.survey.survey_privacy"),
            value: null,
            align: "start",
            sortable: false,
            class: ["primary--text"]
          },
          {
            text: vm.$t("hr.survey.status"),
            value: null,
            align: "start",
            sortable: false,
            class: ["primary--text"]
          }
        ]
      }
    }),
    watch: {
      "table.options": {
        handler() {
          this.fetchItems();
        },
        deep: true
      }
    },
    methods: {
      onRefreshData() {
        this.fetchItems();
      },
      async fetchItems() {
        this.table.loading = true;
        await this.$apollo
          .query({
            query: COMPLETED_SURVEY_RESULTS,
            variables: {
              id: this.$store.state.auth.user.id
            }
          })
          .then(({ data, errors }) => {
            if (!errors && !data.error) {
              this.table.data = data.employee.completedSurveyResults || [];
              this.table.totalItems = data.employee.completedSurveyResults.length || 0;
            }
          })
          .catch(e => {
            this.$helpers.showNotification(e.message);
          })
          .finally(() => (this.table.loading = false));
      }
    }
  };
</script>

<style scoped></style>
